import React, { useEffect, useState } from "react";
import portal from "../../image/learningportal.svg";
import { useLoginMutation } from "../../features/AuthApi/authApi";
import { Link, useNavigate } from "react-router-dom";
const AdminLogin = () => {
  const [error, setError] = useState("");
  const [formData, setData] = useState({
    email: "",
    password: "",
  });

  const changeHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setData({ ...formData, [name]: value });
  };

  const [login, { data, isLoading, error: resError }] = useLoginMutation();

  const navigate = useNavigate();

  useEffect(() => {
    if (resError?.data) {
      setError(resError?.data);
    }
    if (data?.accessToken && data?.user) {
      navigate("/studentportal");
    }
    document.title = "Admin Login";
  }, [data, resError, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (resError?.data) {
      setError(resError.data);
    } else {
      login(formData);
    }

    login(formData);
  };
  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img className="h-12 mx-auto" src={portal} alt="portal" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            Sign in to Admin Account
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <input type="hidden" name="remember" value="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label for="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autocomplete="email"
                required
                className="login-input rounded-t-md"
                placeholder="Email address"
                value={formData.email}
                onChange={changeHandler}
              />
            </div>
            <div>
              <label for="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autocomplete="current-password"
                required
                className="login-input rounded-b-md"
                placeholder="Password"
                value={formData.password}
                onChange={changeHandler}
              />
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div className="text-sm">
              <Link
                to="/admin"
                className="font-medium text-violet-600 hover:text-violet-500"
              >
                Forgot your password?
              </Link>
            </div>
            <div className="text-sm">
              <Link
                to="/"
                className="font-medium text-violet-600 hover:text-violet-500"
              >
                Student?
              </Link>
            </div>
          </div>

          <div>
            <button
              disabled={isLoading}
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
            >
              Sign in
            </button>
          </div>
          {error !== "" && <span>{error}</span>}
        </form>
      </div>
    </section>
  );
};

export default AdminLogin;
